import {GeneralRequest} from "../system/api/Requests";
import {Provider} from "@/models/entities/providers/Provider";
import {ProviderWorker} from "@/models/entities/providerWorkers/ProviderWorker";
import {GeneralResponse} from "@/models/system/api/Responses";
import {Plant} from "@/models/entities/plants/Plant";
import {User} from "@/models/entities/users/User";
import NullOrUndefinedHelper from "@/utilities/system/helpers/NullOrUndefinedHelper";
import {GlobalSetting} from "@/models/entities/settings/GlobalSetting";
import {useSystemStore} from "@/stores/system/SystemStore";
import {EncryptionService} from "@/utilities/services/EncryptionService";

export class ProviderRequest extends GeneralRequest {
    name:string = ""
    zip:string = ""
    city:string = ""
    street:string = ""
    streetnumber:string = ""
    phoneNumber:string = ""
    phone:string = ""
    dialCode:string = ""

    constructor(provider:Provider) {
        super();
        this.name = provider.name
        this.zip = provider.zip
        this.city = provider.city
        this.street = provider.street
        this.streetnumber = provider.streetnumber
        this.phoneNumber = provider.phoneNumber
        this.phone = provider.phoneNumber
        this.dialCode = provider.dialCode
    }
}

export class ConnectSystemToProviderRequest extends GeneralRequest {
    anAbSystemId?:string = undefined; //TODO rename
    companyId:string = "";
    companyIdCode:string = "";
    info:string = "";

    constructor(systemId:(string | undefined) = undefined, companyId:string, companyIdCode:string, info:string) {
        super();
        this.anAbSystemId = systemId;
        this.companyId = companyId;
        this.companyIdCode = companyIdCode;
        this.info = info;
    }
}

export class WorkerRequest extends GeneralRequest {
    firstName:string = ""
    lastName:string = ""
    email:string = ""
    phoneNumber:string = ""
    dialCode:string = ""
    isEnabled:boolean = false
    isAdmin:boolean = false
    isAnonymous:boolean = false
    expirationStatus:boolean = false

    constructor(worker:ProviderWorker) {
        super();
        this.firstName = worker.firstName
        this.lastName = worker.lastName
        this.email = worker.email
        this.phoneNumber = worker.phoneNumber
        this.dialCode = worker.dialCode
        this.isEnabled = worker.isEnabled
        this.isAdmin = worker.isAdmin
        this.isAnonymous = worker.isAnonymous
        this.expirationStatus = worker.anAbSystem?.userConfirmationExpired ?? false;
    }
}

export class PhoneNumberRequest extends GeneralRequest {
    dialCode:string = "";
    phoneNumber:string = "";

    constructor(dialCode:string, phoneNumber:string) {
        super();
        this.dialCode = dialCode;
        this.phoneNumber = phoneNumber;
    }
}

export class PlantRequest extends GeneralRequest {
    name:string = ""
    longitude:number = -1
    latitude:number = -1
    email:string = ""
    applicationRadius:number = -1
    street?:string = undefined
    houseNumber?:string = undefined
    postalcode?:string = undefined
    city?:string = undefined
    phoneNumber:string = ""

    constructor(plant:Plant) {
        super();
        this.name = plant.name
        this.longitude = plant.longitude ?? 0.0
        this.latitude = plant.latitude ?? 0.0
        this.email = plant.email
        this.applicationRadius = plant.applicationRadius ?? 1.0
        this.street = NullOrUndefinedHelper(plant.street) ? undefined : plant.street
        this.houseNumber = NullOrUndefinedHelper(plant.houseNumber) ? undefined : plant.houseNumber
        this.postalcode = NullOrUndefinedHelper(plant.postalcode) ? undefined : plant.postalcode
        this.city = NullOrUndefinedHelper(plant.city) ? undefined : plant.city
        this.phoneNumber = plant.phoneNumber
    }
}

export class UserRequest extends GeneralRequest {
     firstName:string = ""
     lastName:string = ""
     email:string|null = null
     ssoIdentifier:string|null = null
     phoneNumber:string|null = null
     dialCode:string|null = null
     roles:Array<string> = []

    constructor(user:User) {
        super();
        this.firstName = user.firstName
        this.lastName = user.lastName
        this.email = NullOrUndefinedHelper(user.email) ? null : user.email
        this.ssoIdentifier = NullOrUndefinedHelper(user.ssoIdentifier) ? null : user.ssoIdentifier
        this.phoneNumber = NullOrUndefinedHelper(user.phoneNumber) ? null : user.phoneNumber
        this.dialCode = NullOrUndefinedHelper(user.dialCode) ? null : user.dialCode
        this.roles = user.roles
    }
}

export class ChangeOwnerRequest extends GeneralRequest {
    newOwnerId:string;

    constructor(userId:string) {
        super();
        this.newOwnerId = userId;
    }
}

export class EditGlobalSettingRequest extends GeneralRequest {
    displayName:string
    description:string|null
    value:string
    formId:string|null
    formElementId:string|null

    constructor(setting:GlobalSetting) {
        super();
        this.displayName = setting.displayName ?? ""
        this.description = setting.description ?? null
        this.value = setting.value ?? ""
        this.formId = setting.formId ?? null
        this.formElementId = setting.formElementId ?? null
    }
}

export class ChangePasswordRequest extends GeneralRequest {
    userId:string
    encryptedOldPassword:string
    encryptedNewPassword:string
    encryptedNewPasswordRepetition:string

    constructor(userId:string, current:string, changed:string, changedRepetition:string) {
        super();
        this.userId = userId
        this.encryptedOldPassword = current
        this.encryptedNewPassword = changed
        this.encryptedNewPasswordRepetition = changedRepetition
    }
}